import React from "react";

export default function Hero() {
  return (
    <section className="flex items-center justify-center bg-gray-50 pt-32 pb-16">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h1 className="text-[1.45rem] md:text-[1.85rem] lg:text-[2.35rem] font-normal text-gray-900 mb-2 leading-tight">
          Innovative voice technologies<br />
          for tactical radio communications
        </h1>
        <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed font-normal">
          Robustness, security, and voice intelligibility in constrained environments
        </p>
      </div>
    </section>
  );
}
